import counts from './counts';

const root = {
	counts
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js